export const HOMII_KEYS = {
    PREBOOKING_KEY: 'homii-prebooking-id',
    TRANSACTION_KEY: 'homii-transaction-id',
    TRANSACTION_CHECKOUT_ID: 'homii-transaction-checkout-id',
    TRANSACTION_CHECKSUM: 'homii-transaction-checksum',
    PAYMENT_GATEWAY: 'homii-payment-gateway',
    QUOTE_PARAMS: 'homii-quote-params',
    PAYMENT_METHOD: 'homii-payment-method',
    PAYMENT_STEP_DATA: 'homii-payment-step-data',
    LOCAL_STORAGE_KEY: 'homii-local-storage',
    EMBEDDED_REDIRECT_URL: 'homii-embedded-redirect-url',
    SELECTED_CITY: 'homii-selected-city',
    SUCCESSFUL_BOOKING_EVENT: 'homii-successful-booking-event',
    PROMO_MODAL_SESSION_KEY: 'homii-promo-modal-shown',
};

export const CONSTANTS = {
    NEARBYID: 'nearby',
    NEARBY: 'Nearby',
};

export const GENDERS = Object.freeze({
    unknown: 0,
    female: 1,
    male: 2,
});

export const PAYMENT_STATUS_ENUM = ['PENDING', 'SUCCESS', 'FAILED'];

export const stepOneTypes = {
    LOG_IN: 'log-in',
    SIGN_UP: 'sign_up',
};

export const steps = {
    AUTHENTICATION: 'authentication',
    PAYMENT: 'payment',
    CONFIRMATION: 'confirmation',
    LOADING: 'loading',
    ERROR: 'error',
};

export const stepTwoTypes = {
    SELECTION: 'selection',
    CREDIT_CARD: 'card',    
};

export const PaymentGatewayOption = {
    PEACH_PAYMENT: '1',
    PAYGATE: '2',
};